import get from 'lodash/get';

const { hostname } = window.location;

const clientIdByHostname: Record<string, string> = {
  'auth.demo-myaccount-login.revers.io': 'demo-myaccount.revers.io',
  'auth.demo-auchan-login.revers.io': 'demo-auchan.revers.io',
  'auth.demo-ekinsport-login.revers.io': 'demo-ekinsport.revers.io',
  'auth.sav-login.demo.auchan.fr': 'demo-auchan.revers.io',
};

const authorityByHostname: Record<string, string> = {
  'auth.demo-auchan-login.revers.io': 'https://demo-auchan-login.revers.io',
  'auth.sav-login.demo.auchan.fr': 'https://sav-login.demo.auchan.fr',
};

const authorityByClientId: Record<string, string> = {
  'demo-myaccount.revers.io': 'https://demo-myaccount-login.revers.io',
  'demo-retours.carrefour.fr': 'https://demo-retours-login.carrefour.fr',
  'demo-auchan.revers.io': 'https://demo-auchan-login.revers.io',
  'demo-ekinsport.revers.io': 'https://demo-ekinsport-login.revers.io',
};

const defaultClientId = 'demo-myaccount.revers.io';

function computeAuthority({ clientId }: { clientId: string }) {
  const defaultAuthority = get(authorityByClientId, clientId);
  const defaultAuthorityFromHostname = get(authorityByHostname, hostname);

  if (hostname !== 'localhost' && defaultAuthorityFromHostname) {
    return defaultAuthorityFromHostname;
  }

  if (defaultAuthority) {
    return defaultAuthority;
  }

  const builtAuthorityFromClientId = clientId.replace(
    '.revers.io',
    '-login.revers.io',
  );

  return builtAuthorityFromClientId.includes('https://')
    ? builtAuthorityFromClientId
    : `https://${builtAuthorityFromClientId}`;
}

function setAuthority(authority?: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { clientId } = this;

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  this.authority = authority || computeAuthority({ clientId });

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return this;
}

function computeClientId() {
  if (import.meta.env.VITE_CLIENTID) {
    return import.meta.env.VITE_CLIENTID;
  }

  if (hostname === 'localhost') {
    return defaultClientId;
  }

  if (clientIdByHostname[hostname]) {
    return clientIdByHostname[hostname];
  }

  if (window.location.hostname.includes('.auth.demo.revers.io')) {
    return window.location.hostname.replace(
      '.auth.demo.revers.io',
      '.selfcare.demo.revers.io',
    );
  }

  if (window.location.hostname.includes('-auth')) {
    return window.location.hostname.replace('-auth', '');
  }

  if (window.location.hostname.includes('auth.')) {
    return window.location.hostname.replace('-login', '').replace('auth.', '');
  }

  return window.location.hostname;
}

const clientId = computeClientId();

const AuthConfiguration = {
  clientId,
  authority: computeAuthority({ clientId }),
  scope: 'openid email api',
  setAuthority,
};

export default AuthConfiguration;
